import React from "react";

const CardMusic = ({ cardData }) => {
  return (
    <div className="card-music">
      <div className="card-music__overlay"></div>
      <div className="card-music__text">
        <p className="card-music__text__headline">
          {cardData.frequency} {cardData.title}
        </p>
        <p className="card-music__text__subheadline"> {cardData.text}</p>
      </div>
      <picture>
        {cardData.sources.map((source, idx) => (
          <source
            key={idx}
            media={source.media}
            sizes={source.sizes}
            srcSet={source.srcSet
              .map((item) => `${item.src} ${item.width}`)
              .join(", ")}
          />
        ))}
        <img loading="lazy" src={cardData.fallback} alt={cardData.altImg} />
      </picture>
    </div>
  );
};

export default CardMusic;
